<script setup lang="ts">
import {Model} from "@/app/Model";
import {Comms} from "@/app/Comms";
import {Modal} from "bootstrap";
let model: Model = Model.getReactiveInstance();
let comms: Comms = Comms.getInstance();
function handleSubmit(): void {
  if (model.pen_admin.itemReatoRubrica.capo_imputazione_str == "" || model.pen_admin.itemReatoRubrica.tip_atto == "") {
    alert("Inserire almeno un Capo Imputazione e un Tipo Atto");
    return;
  }
  if (model.pen_admin.insertModeReatoRubrica) {
    comms.penaleAdmin.chiamataReatoRubricaAdd( ()=> {} )
    const modal = Modal.getOrCreateInstance('#ModalAdminReatoRubricaItem');
    modal.hide();
  } else {
    comms.penaleAdmin.chiamataReatoRubricaSave( ()=> {} )
  }
}
</script>


<template>
  <div class="modal fade" id="ModalAdminReatoRubricaItem" tabindex="-1" aria-labelledby="labelModalAdminReatoRubricaItem"
       aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-xl">
      <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="labelModalAdminReatoRubricaItem" v-if="model.pen_admin.insertModeReatoRubrica">Aggiungi elemento</h1>
            <h1 class="modal-title fs-5" id="labelModalAdminReatoRubricaItem" v-else>Modifica
              {{ model.pen_admin.itemReatoRubrica.id }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">

            <div class="mb-3">
              <label for="capo_imputazione_str" class="form-label">Capo Imputazione</label>
              <input type="text" class="form-control" id="capo_imputazione_str"
                     v-model.number="model.pen_admin.itemReatoRubrica.capo_imputazione_str">
            </div>
            <div class="mb-3">
              <label for="tip_atto" class="form-label">Tipo Atto</label>
              <input type="text" class="form-control" id="tip_atto" @change="model.pen_admin.itemReatoRubrica.tip_atto = model.pen_admin.itemReatoRubrica.tip_atto?.toUpperCase()"
                     v-model.number="model.pen_admin.itemReatoRubrica.tip_atto">
            </div>
            <div class="mb-3">
              <label for="rubrica" class="form-label">Rubrica</label>
              <input type="text" class="form-control" id="rubrica"
                     v-model.number="model.pen_admin.itemReatoRubrica.rubrica">
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="handleSubmit()" :disabled="comms.penaleAdmin.inChiamataReatoRubricaSave || comms.penaleAdmin.inChiamataReatoRubricaAdd">Salva</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
          </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>